// extracted by mini-css-extract-plugin
export var videoContainer = "_jw-0";
export var videoIframe = "_jw-3";
export var videoLink = "_jw-1";
export var videoOverlay = "_jw-4";
export var videoOverlayText = "_jw-5";
export var videoWrapper = "_jw-2";